var _path, _rect, _ellipse, _path2, _rect2, _ellipse2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _circle, _path16, _path17, _ellipse7, _ellipse8, _ellipse9, _ellipse10, _circle2, _path18, _path19, _path20, _path21, _ellipse11, _ellipse12, _path22, _path23;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGirafaAbout(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 181,
    height: 154,
    viewBox: "0 0 181 154",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M142.634 75C122.401 75 106 91.4015 106 111.634C106 131.866 122.401 148.267 142.634 148.267C162.866 148.267 179.267 131.866 179.267 111.634C179.267 91.4013 162.866 75 142.634 75ZM148.739 135.104C148.739 136.486 147.619 137.607 146.237 137.607H139.372C137.99 137.607 136.87 136.486 136.87 135.104V107.25C136.87 105.868 137.99 104.748 139.372 104.748H146.237C147.619 104.748 148.739 105.868 148.739 107.25V135.104ZM142.634 100.006C139.203 100.006 136.422 97.2253 136.422 93.7946C136.422 90.364 139.203 87.5828 142.634 87.5828C146.064 87.5828 148.845 90.364 148.845 93.7946C148.845 97.2253 146.064 100.006 142.634 100.006Z",
    fill: "#28ACDF",
    stroke: "black",
    strokeWidth: 1.8
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 54.7676,
    y: 17.9443,
    width: 9.44278,
    height: 18.8856,
    fill: "#70544B"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 59.0168,
    cy: 11.3313,
    rx: 12.7477,
    ry: 11.3313,
    fill: "#70544B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.4179 0.83331C44.1787 4.19393 43.3758 17.9064 53.2201 21.2911L54.9049 21.8705V29.3486V36.8268H59.8827H64.8605V29.2657V21.7047L66.2553 21.0189C80.1623 14.1805 69.443 -4.09821 54.4179 0.83331ZM64.3628 2.78698C72.8842 6.46061 73.0229 15.8367 64.6116 19.6085C55.5387 23.6768 45.1569 16.1411 48.7063 8.06338C51.0328 2.76938 58.4909 0.255818 64.3628 2.78698ZM62.8695 28.5436V34.9336H59.8827H56.8961V28.805V22.6765L59.5093 22.5026C60.9468 22.407 62.2907 22.2893 62.4961 22.2413C62.7014 22.1931 62.8695 25.0291 62.8695 28.5436Z",
    fill: "#20312D"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 9.44278,
    height: 18.8856,
    transform: "matrix(-1 0 0 1 101.98 17.9443)",
    fill: "#70544B"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.7477,
    cy: 11.3313,
    rx: 12.7477,
    ry: 11.3313,
    transform: "matrix(-1 0 0 1 110.479 0)",
    fill: "#70544B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102.329 0.83331C112.568 4.19393 113.371 17.9064 103.527 21.2911L101.842 21.8705V29.3486V36.8268H96.8644H91.8865V29.2657V21.7047L90.4918 21.0189C76.5848 14.1805 87.3041 -4.09821 102.329 0.83331ZM92.3843 2.78698C83.8629 6.46061 83.7241 15.8367 92.1355 19.6085C101.208 23.6768 111.59 16.1411 108.041 8.06338C105.714 2.76938 98.2561 0.255818 92.3843 2.78698ZM93.8776 28.5436V34.9336H96.8644H99.851V28.805V22.6765L97.2377 22.5026C95.8003 22.407 94.4564 22.2893 94.251 22.2413C94.0457 22.1931 93.8776 25.0291 93.8776 28.5436Z",
    fill: "#20312D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.5497 30.0939C53.7024 31.24 41.2623 36.3102 37.2993 40.7926L36.4341 41.771L21.9603 36.8882C2.30384 30.2573 3.70341 30.3371 1.71604 35.7362C-3.66652 50.3593 3.86057 62.4537 20.8232 66.4383C23.352 67.0323 25.5177 67.5911 25.636 67.6795C25.7539 67.7679 26.0077 70.7529 26.1998 74.3123C26.6804 83.2146 28.511 91.7071 32.8334 105.09C45.2182 143.436 55.1727 153.966 78.9901 153.918C100.069 153.875 110.102 144.861 119.942 117.126C128.344 93.4422 130.843 83.8653 130.942 74.9681C130.961 73.2345 131.12 70.87 131.296 69.7132L131.615 67.6099L134.682 66.9938C152.956 63.3228 160.664 52.0339 155.678 36.2485C153.788 30.266 154.862 30.2283 134.411 36.9911L120.688 41.5289L118.128 39.617C106.805 31.1599 85.8296 27.4999 63.5497 30.0939Z",
    fill: "#20312D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.4054 31.6957C29.2314 34.7746 19.2743 59.4042 35.7542 107.517C47.8077 142.707 56.8174 152.013 78.7406 151.915C101.273 151.815 109.78 141.802 123.596 99.1187C139.379 50.3598 119.797 27.2738 66.4054 31.6957ZM3.12868 37.1706C-0.93541 50.8605 5.0275 60.0953 20.4713 64.0298C26.3591 65.5294 26.279 65.5351 26.279 63.6383C26.279 59.5124 29.2783 50.86 32.2389 46.4447C33.3873 44.7327 34.2459 43.2509 34.1474 43.1519C33.784 42.789 5.71149 33.5511 4.97034 33.5511C4.42315 33.5511 3.89536 34.5873 3.12868 37.1706ZM136.703 38.2477C120.196 43.7481 121.759 42.8605 123.826 45.5688C127.134 49.9024 130.244 58.5528 130.253 63.4443C130.257 65.5703 130.352 65.5841 135.917 64.2498C151.035 60.6262 157.642 50.7564 153.781 37.5683C152.355 32.6997 153.487 32.6543 136.703 38.2477Z",
    fill: "#F3BD3E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M119.998 88.1173C122.507 87.5104 128.968 82.9238 128.024 86.2287C129.655 89.0208 125.34 95.2405 123.86 99.2803C122.4 103.319 122.57 110.425 119.998 109.364C117.425 108.302 111.236 98.9188 111.1 94.8038C110.984 90.6874 115.773 89.1393 119.998 88.1173Z",
    fill: "#70544B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M75.9172 53.3953C70.3312 56.871 64.31 54.4855 58.0302 48.9112C52.8319 44.2971 49.0655 35.9321 51.4197 32.386C57.5061 32.3863 71.6038 27.6109 72.1403 30.7323C72.6767 33.8537 83.1609 48.8879 75.9172 53.3953Z",
    fill: "#70544B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M128.663 56.5108C129.796 59.9659 130.177 64.2623 127.886 66.1068C125.595 67.9513 122.484 65.5601 119.388 63.2739C116.291 61.0138 115.574 57.0525 116.556 53.8312C117.538 50.6098 120.39 47.0142 123.638 47.222C126.885 47.4558 127.53 53.0556 128.663 56.5108Z",
    fill: "#70544B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1947 76.274C38.2119 79.6876 35.8836 85.5651 35.8836 85.5651C35.8836 85.5651 32.5014 91.2802 29.721 89.0216C28.8717 85.5651 26.0302 77.3089 26.9118 74.1263C27.7934 70.9437 27.9943 69.7036 30.9104 69.9089C33.8265 70.1399 36.1774 72.8605 37.1947 76.274Z",
    fill: "#70544B"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M91.4521 30.7979C95.3769 31.1627 102.475 31.8502 100.206 35.7856C97.9373 39.7211 96.9709 50.9973 91.4533 53.0963C86.1306 55.1211 85.7574 47.4924 83.1082 43.1796C80.3644 38.7128 76.5367 33.4081 77.9206 30.799C79.3044 28.1898 87.502 30.4217 91.4521 30.7979Z",
    fill: "#70544B"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M105.149 37.7439C105.504 36.5155 105.161 35.0999 106.406 34.7209C107.664 34.3452 109.915 34.9207 111.05 35.9838C119.922 40.6032 115.893 41.9053 113.783 44.8516C111.809 47.6093 106.409 46.1991 105.15 45.7968C100.093 42.4918 104.277 40.7654 105.149 37.7439Z",
    fill: "#70544B"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7886 42.0369C39.1268 39.5081 42.2571 37.7377 44.961 39.1115C47.6772 40.5103 49.967 45.0533 49.5278 48.6057C49.0673 52.1685 45.8777 54.7406 42.3899 55.0156C38.89 55.2657 32.3279 53.7244 31.2127 51.052C30.0974 48.3796 34.4289 44.5762 36.7886 42.0369Z",
    fill: "#70544B"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M32.664 96.0309C34.0657 93.9577 36.1485 92.697 38.3183 94.3307C40.5002 95.9895 42.7693 100.543 42.8989 103.818C43.0142 107.101 40.99 109.106 38.4527 108.918C35.9031 108.706 34.9696 107.078 33.8057 104.429C32.6419 101.781 31.2478 98.1111 32.664 96.0309Z",
    fill: "#70544B"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.1865 102.871C59.5735 104.357 52.6806 106.99 45.6669 111.476C37.909 116.438 37.4809 117.508 40.3201 124.838C55.4817 163.979 102.468 163.499 116.693 124.059C119.003 117.653 118.63 116.423 113.157 112.41C101.454 103.828 84.0484 100.136 68.1865 102.871Z",
    fill: "#20312D"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.2954 105.222C57.9807 106.862 39.5113 115.922 40.6541 120.254C51.3583 160.826 101.509 163.833 114.896 123.739C116.628 118.864 116.622 118.755 114.488 116.845C104.282 107.704 87.5962 103.214 71.2954 105.222Z",
    fill: "#FFF2C5"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 61.5295,
    cy: 86.4023,
    rx: 11.3313,
    ry: 12.7477,
    transform: "rotate(-10 61.5295 86.4023)",
    fill: "#20312D"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 61.519,
    cy: 86.4026,
    rx: 9.44278,
    ry: 10.8592,
    transform: "rotate(-10 61.519 86.4026)",
    fill: "white"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 61.9271,
    cy: 86.7364,
    rx: 7.40192,
    ry: 8.22435,
    transform: "rotate(-10 61.9271 86.7364)",
    fill: "#70544B"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 61.76,
    cy: 86.8286,
    rx: 4.72139,
    ry: 5.66567,
    transform: "rotate(-10 61.76 86.8286)",
    fill: "#20312D"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 62.2525,
    cy: 81.4675,
    r: 3.30497,
    transform: "rotate(-10 62.2525 81.4675)",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M63.7737 67.0444C63.4099 69.6373 59.8826 68.3353 57.2631 68.6452C54.6435 68.9552 50.789 71.7286 49.8427 68.9864C48.8643 66.1514 53.4385 65.9526 56.721 65.5708C59.5159 65.2458 64.1647 64.2579 63.7737 67.0444Z",
    fill: "#20312D"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M94.1077 66.1001C94.4715 68.6929 97.9987 67.391 100.618 67.7009C103.238 68.0109 107.092 70.7843 108.039 68.0421C109.017 65.207 104.443 65.0082 101.16 64.6265C98.3655 64.3014 93.7167 63.3136 94.1077 66.1001Z",
    fill: "#20312D"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 95.6687,
    cy: 86.2864,
    rx: 11.3313,
    ry: 12.7477,
    transform: "rotate(10 95.6687 86.2864)",
    fill: "#20312D"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 95.6607,
    cy: 86.2832,
    rx: 9.44278,
    ry: 10.8592,
    transform: "rotate(10 95.6607 86.2832)",
    fill: "white"
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 95.9297,
    cy: 86.7368,
    rx: 7.40192,
    ry: 8.22435,
    transform: "rotate(10 95.9297 86.7368)",
    fill: "#70544B"
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 95.7391,
    cy: 86.7657,
    rx: 4.72139,
    ry: 5.66567,
    transform: "rotate(10 95.7391 86.7657)",
    fill: "#20312D"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 98.0344,
    cy: 81.8975,
    r: 3.30497,
    transform: "rotate(10 98.0344 81.8975)",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.47193 39.8313C4.11759 41.0247 3.29203 43.3992 4.05158 46.7929C6.18603 56.3306 16.539 58.2132 23.6018 50.348L26.0416 47.6309L27.8831 48.2806C29.9047 48.9939 30.5775 48.8246 30.5538 47.6089C30.5281 46.2876 15.1716 40.0079 10.2421 39.3029C8.67451 39.0787 7.68251 39.2177 6.47193 39.8313Z",
    fill: "#20312D"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.42726 41.9956C4.47028 44.087 6.53029 50.4586 9.78382 52.3771C13.4283 54.5261 19.1618 53.0626 22.8127 49.0513C25.4388 46.1661 25.6099 46.4303 19.6383 44.1478C11.0422 40.8622 7.95808 40.3598 6.42726 41.9956Z",
    fill: "#FFF2C5"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M150.36 39.706C152.657 41.007 153.372 43.4171 152.456 46.7721C149.883 56.2009 139.453 57.6025 132.76 49.4188L130.449 46.5918L128.579 47.1556C126.526 47.7746 125.862 47.5744 125.942 46.361C126.029 45.0424 141.661 39.4799 146.618 39.0037C148.195 38.8522 149.179 39.0371 150.36 39.706Z",
    fill: "#20312D"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M150.306 41.8695C152.164 44.0493 149.811 50.3187 146.472 52.0846C142.731 54.0627 137.071 52.3355 133.609 48.1596C131.119 45.156 130.936 45.4119 137.007 43.4082C145.747 40.5238 148.852 40.1647 150.306 41.8695Z",
    fill: "#FFF2C5"
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 68.9006,
    cy: 122.757,
    rx: 4.72139,
    ry: 5.66567,
    transform: "rotate(-10 68.9006 122.757)",
    fill: "#20312D"
  })), _ellipse12 || (_ellipse12 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 88.6979,
    cy: 122.545,
    rx: 4.72139,
    ry: 5.66567,
    transform: "rotate(-170 88.6979 122.545)",
    fill: "#20312D"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M78.9007 141.642C74.4635 141.642 70.2111 140.046 67.4378 137.434C66.8832 136.853 66.8832 135.837 67.6227 135.402C68.3623 134.966 69.6565 134.966 70.2111 135.547C72.4297 137.579 75.5728 138.74 78.9007 138.74C82.2286 138.74 85.3716 137.579 87.4054 135.547C87.96 134.966 89.2542 134.821 89.9937 135.402C90.7333 135.837 90.9182 136.853 90.1786 137.434C87.5903 140.046 83.3379 141.642 78.9007 141.642Z",
    fill: "#20312D"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.1913 29.7055C29.8906 33.6083 18.4601 57.3322 30.2317 98.1126C42.6227 141.038 53.8963 154.025 78.7451 154C103.278 153.975 112.888 142.419 127.075 95.8858C132.51 78.0576 132.28 59.8805 126.478 48.861C118.549 33.8008 93.3434 26.1717 63.1913 29.7055ZM94.5208 32.3322C111.039 35.2515 122.262 42.9885 126.159 54.144C131.602 69.7244 129.047 86.341 115.83 121.324C107.108 144.407 94.0657 153.897 73.8801 151.846C54.1877 149.846 43.8622 136.332 32.6454 97.8758C21.8169 60.7522 29.4149 40.2308 56.5098 33.421C65.7137 31.108 84.542 30.5684 94.5208 32.3322Z",
    fill: "#20312D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGirafaAbout);
export default __webpack_public_path__ + "static/media/girafa-about.3943a7dd68a2f5bcbab135e1a6fdd10f.svg";
export { ForwardRef as ReactComponent };